export const AppURL = {
    Login : 'login',
    Register : 'register',
    ForGotPassWord : 'forgot-password',
    ChangePassWord : 'change-password',
    VerifyEmail :  'verify-email',
    Authen : 'cbn',
}